import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { stackClientApp } from '../stackClient';

const LogoutButton = () => {
  const [message, setMessage] = useState('');
  const navigate = useNavigate();
  const [activePage, setActivePage] = useState('');
  const location = useLocation();

  useEffect(() => {
    setActivePage(location.pathname);
  }, [location]);

  const handleLogout = async () => {
    try {
      const user = await stackClientApp.getUser();
      if (user) {
        await user.signOut();
      }

      // Clear any local data you stored
      localStorage.removeItem('stack_access_token');
      localStorage.removeItem('stack_user_id');
      localStorage.removeItem('name');
      localStorage.removeItem('user_email');

      setMessage('You have been logged out.');

      setTimeout(() => {
        navigate('/login');
      }, 1500);
    } catch (error) {
      console.error('Error logging out:', error);
      setMessage('Failed to logout. Please try again.');
    }
  };

  const handleCloseMessage = () => {
    setMessage('');
    navigate('/login');
  };

  return (
    <>
      <button
        onClick={handleLogout}
        className={`${
          activePage === '/logout'
            ? 'bg-pacificgreen text-white'
            : 'text-gray-300 hover:bg-gray-700 hover:text-white'
        } rounded-md px-3 py-2 text-sm font-medium`}
      >
        LOG OUT
      </button>
      {message && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-4 rounded-md shadow-lg flex flex-col items-center">
            <p>{message}</p>
            <button
              onClick={handleCloseMessage}
              className="mt-4 bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded"
              style={{ backgroundColor: '#0D2329' }}
            >
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default LogoutButton;
